import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import {
  CloseButton,
  FooterActions,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  PrimaryButton,
  TextButton,
} from './workspaceModalParts';

// Post-save nudge: offer to mark the question's open QC issues Ready in the same motion.

const BodyText = styled('p')({
  margin: 0,
  fontSize: '0.9rem',
  lineHeight: 1.6,
  color: 'rgba(0,0,0,0.75)',
});

export interface MarkReadyPromptModalProps {
  open: boolean;
  openCount: number;
  onMarkReady: () => void;
  onClose: () => void;
}

export default function MarkReadyPromptModal({ open, openCount, onMarkReady, onClose }: MarkReadyPromptModalProps): JSX.Element {
  const plural = openCount === 1 ? '' : 's';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label='Mark QC issues ready'
      PaperProps={{ sx: { width: 520, maxWidth: 'calc(100% - 32px)', borderRadius: '4px' } }}
      maxWidth={false}
    >
      <ModalHeader>
        <ModalTitle>Finding saved — update the QC issue{plural}?</ModalTitle>
        <CloseButton type='button' aria-label='Close mark ready prompt' onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </ModalHeader>
      <ModalBody>
        <BodyText>
          This question has {openCount} open QC issue{plural}. If your update resolves
          {openCount === 1 ? ' it' : ' them'}, mark {openCount === 1 ? 'it' : 'them'} Ready
          for TPN Review — same as clicking the button on the issue card.
        </BodyText>
      </ModalBody>
      <ModalFooter>
        <FooterActions>
          <TextButton type='button' onClick={onClose}>Not Yet</TextButton>
          <PrimaryButton type='button' onClick={onMarkReady}>
            <SendIcon sx={{ fontSize: 16 }} />
            Mark Ready for TPN Review
          </PrimaryButton>
        </FooterActions>
      </ModalFooter>
    </Dialog>
  );
}
